module.exports = "https://static.wmbcdn.com/uniweb/images/ae04f4ae81ca7e0a532c4b49a82d72ee.svg";